import { render, staticRenderFns } from "./MessagesList.vue?vue&type=template&id=1f71940a&"
import script from "./MessagesList.vue?vue&type=script&lang=js&"
export * from "./MessagesList.vue?vue&type=script&lang=js&"
import style0 from "./MessagesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports